/**
 * RunStats: cheap "fun metrics" recorded per fixed-step during a run and
 * surfaced on the win / death overlays.
 *
 * Tracking is intentionally minimal:
 *   - topSpeed : peak |v| of the torso, in world-units/sec
 *   - whips    : number of times the hook attached during the run
 *   - airTimeS : seconds of fixed-step time spent off the ground
 *
 * These are computed without allocations in the hot path and don't influence
 * physics / replay determinism — they're observational only.
 */

export interface RunStats {
  topSpeed: number;
  whips: number;
  airTimeS: number;
}

export function newRunStats(): RunStats {
  return { topSpeed: 0, whips: 0, airTimeS: 0 };
}

/** Format the per-run summary line shown under the win/death subtitle.
 *  Keeps the text short so it fits one screen row at small viewports. */
export function formatStatsLine(s: RunStats): string {
  const speed = Math.round(s.topSpeed);
  const air = s.airTimeS.toFixed(1);
  return `top ${speed} \u00b7 whips ${s.whips} \u00b7 air ${air}s`;
}
